import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Slider from "react-slick";
import whatsappIcon from "../../assets/whatsapp.svg";
import callIcon from "../../assets/callIcon.svg";
import HoverButton from "../HoverButton";
import { WhatsappRedirection, callRedirectionNo } from "../../api/Redirection";

const EventContainer = ({
  imgList,
  title,
  description,
  price,
  facilityList,
  SliderPosition,
}) => {
  const isLargeScreen = useMediaQuery("(min-width:1200px)");
  const isBetween600and700 = useMediaQuery(
    "(min-width:600px) and (max-width:800px)"
  );

  const handleWhatsAppClick = () => {
    window.open(WhatsappRedirection, "_blank");
  };

  const handleCallClick = () => {
    window.open(callRedirectionNo, "_blank");
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const DecorStyle = {
    mainContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 5,
      padding: {
        xs: "0px 0px",
        sm: "0px 0px",
        md: "0px 0px",
        lg: "0 50px",
        xl: "0 50px"
      },
      boxSizing: "border-box",
      margin: "50px auto",
      maxWidth: {
        xs: '300px',
        sm: "700px",
        md: "1200px",
        lg: "1200px",
        xl: "1200px"
      },
    },
    sliderBox: {
      flex: 1,
      width: isBetween600and700
        ? "50%"
        : { xs: "100%", sm: "100%", md: "70%", lg: "55%" },
      height: isLargeScreen ? "auto" : "340px",
      alignItems: "center",
    },
    textBox: {
      flex: 1,
      width: isBetween600and700
        ? "50%"
        : { xs: "100%", sm: "100%", md: "70%", lg: "55%" },
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
    },
    title: {
      width: "339px",
      fontFamily: "ZapfHumnst BT",
      fontWeight: "400",
      fontSize: {
        xs: "24px",

        md: "40px",
      },
      lineHeight: {
        xs: "29.71px",

        md: "49.51px",
      },
      letterSpacing: "0.05em",
      color: "#181818",
      pb: 1,
    },
    description: {
      width: isLargeScreen ? "426px" : "100%",
      fontFamily: "sora",

      fontWeight: "300",
      fontSize: {
        xs: "11px",

        md: "16px",
      },
      lineHeight: {
        xs: "18px",

        md: "24px",
      },
      letterSpacing: "0.01em",
      color: "#000000",
      pb: 1,
    },
    priceBox: {
      width: { xs: "178px", sm: "208px" },
      display: "flex",
      color: "#442A0B",
      flexDirection: "column",
    },
    priceText: {
      fontFamily: "sora",

      fontWeight: "600",
      fontSize: {
        xs: "20px",

        md: "24px",
      },
      lineHeight: {
        xs: "25.2px",

        md: "30.24px",
      },
      letterSpacing: "0.01em",
      color: "#442A0B",
    },
    priceSubText: {
      fontFamily: "sora",

      fontWeight: "300",
      fontSize: {
        xs: "10px",

        md: "11px",
      },
      lineHeight: {
        xs: "26px",

        md: "15.12px",
      },
      letterSpacing: "0.01em",
      color: "#442A0B",
    },
    facilityText: {
      fontFamily: "sora",

      fontWeight: "300",
      fontSize: {
        xs: "11px",

        md: "14px",
      },
      lineHeight: {
        xs: "13.86px",

        md: "22px",
      },
      letterSpacing: "0.01em",
      color: "#4D4D4D",
      marginBottom: "5px",
    },
    actionButtonBox: {
      display: "flex",
      gap: 2,
      marginTop: 2,
    },
  };

  return (
    <Box

      flexDirection={
        isLargeScreen
          ? SliderPosition === "left"
            ? "row"
            : "row-reverse"
          : "column"
      }

      sx={DecorStyle.mainContainer}
    >
      {/* Slider Section */}
      <Box sx={DecorStyle.sliderBox}>
        <Slider {...settings}>
          {imgList.map((img, index) => (
            <Box key={index}>
              <img
                src={img}
                alt={`Slide ${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Slider>
        <style jsx>{`
          .slick-dots {
            position: absolute;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
          }
          .slick-dots li button:before {
            color: #fff;
          }
          .slick-dots li.slick-active button:before {
            color: #fff;
          }
        `}</style>
      </Box>

      {/* Event Information Section */}
      <Box sx={DecorStyle.textBox}>
        <Typography sx={DecorStyle.title}>{title}</Typography>
        <Typography sx={DecorStyle.description}>{description}</Typography>
        <Box sx={DecorStyle.priceBox}>
          <Typography sx={DecorStyle.priceText}>
            {`RS ${price}`}
            <span style={{ fontWeight: "300" }}>
              {"/"}
            </span>
            <span
              style={{
                fontSize: "12px",
                lineHeight: "15.12px",
                fontWeight: "300",
              }}
            >
              per night
            </span>
          </Typography>
          <Typography sx={DecorStyle.priceSubText}>
            Inclusive all taxes and GST{" "}
          </Typography>
        </Box>

        <Box>
          <ul style={{ paddingLeft: 13 }}>
            {facilityList.map((facility, index) => (
              <Typography
                component="li"
                key={index}
                sx={DecorStyle.facilityText}
              >
                {facility}
              </Typography>
            ))}
          </ul>
        </Box>
        {/* Action Buttons */}
        <Box sx={DecorStyle.actionButtonBox}>
          <HoverButton
            onClick={handleWhatsAppClick}
            btnText="Enquire Now"
            width="180px"
            startIcon={<img src={whatsappIcon} alt="WhatsApp" />}
          />
          <HoverButton
            onClick={handleCallClick}
            btnText={
              <img
                src={callIcon}
                alt="Call Icon"
                style={{ marginTop: "5px" }}
              />
            }
            width="50px"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EventContainer;
